import { render } from "./RightSidebar.vue?vue&type=template&id=3f11a5c8"
import script from "./RightSidebar.vue?vue&type=script&lang=js"
export * from "./RightSidebar.vue?vue&type=script&lang=js"

import "./RightSidebar.vue?vue&type=style&index=0&id=3f11a5c8&lang=css"

import exportComponent from "/tmp/build_d537e74c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__